import { api } from '@api/api2';

export const getList = () =>
  api.no_vers('get', 'scud/get-access-groups', {
    ...{ limit: 9999999999 },
  });
